export default function (voted) {
  if (typeof voted === 'boolean') {
    return voted
  }

  return voted.filter(vote => vote.voted === true).length === voted.length
}
